import axios from '@/components/api/axios';

async function getCampaign(id) {
  let data = {
    id: id
  }
  const res = await axios.axiosGet('/api/campaign/getCampaign', data);
  return res;
}

async function entryCampaign(id) {
  let data = {
    id: id
  }
  const res = await axios.axiosPost('/api/campaign/entry', data);
  return res;
}


export default {
  getCampaign,
  entryCampaign
}



// WEBPACK FOOTER //
// ./src/components/api/campaign.js